export default "__VITE_ASSET__BiL0ZVAh__"